import "./profile.css";
import Topbar from "../../components/topbar/Topbar";
import axiosInstance from '../../config';
import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import SocialContext from '../../context/SocialContext';
import Bottom from "../../components/Bottom/Bottom";
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import CloseFriend from "../../components/closeFriend/CloseFriend";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Alertjs from "../../components/alert/Alert";
import UserPost from "../../components/recentActivity/UserPost";
import Progress from '../../components/Progress/Progress'

export default function Profile() {
  const navigate = useNavigate();
  const { setuser: setcurrentuser, user: currentuser, showalert, scrolltoTopfun, isfetching } = useContext(SocialContext);
  const PF = "https://socialshub.netlify.app/images/";

  const userID = useParams().userID;  // store username from url

  const [user, setuser] = useState({})    // this is empty object // store profil's user details
  const [showfollowings, setshowfollowings] = useState(false);
  const [showfollowers, setshowfollowers] = useState(false);
  const [loading, setloading] = useState(false)

  // for fetch user's profile 
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setloading(true);
        const response = await axiosInstance.get(`/api/users?userId=${userID}`);
        setuser(response.data);
        setloading(false);
      } catch (error) {
        console.log("errot inside profile ",error);
        navigate('*');
        // setloading(false);
      }
    }
    fetchUser();
    setshowfollowings(false);
    setshowfollowers(false);
  }, [userID]);



  // --------->>>>>> for follow / unfollow <<<<<<-------
  const [isfollow, setisfollow] = useState(false);

  const funTofetchCurrendUser = async () => {
    try {
      const id = window.localStorage.getItem('currentUID');
      const response = await axiosInstance.get(`/api/users?userId=${id}`);
      setisfollow(response.data.followings.includes(userID));
      setcurrentuser(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  // check if 
  useEffect(() => {
    if (window.localStorage.getItem("currentUID")) {
      funTofetchCurrendUser();
    } else {
      navigate('/');
    }
    scrolltoTopfun();
    window.document.title= currentuser.username+' | SocialHub';
  }, [])




  // follow function
  const followfun = async () => {
    try {
      if (isfollow) {
        await axiosInstance.put("/api/" + "users/" + user._id + "/unfollow", { userId: currentuser._id });

        // for user or frontend
        const newuser = user;
        newuser.followers = newuser.followers.filter(function (item) {
          return item !== currentuser._id;
        })
        setuser(newuser);
      } else {
        await axiosInstance.put("/api/" + "users/" + user._id + "/follow", { userId: currentuser._id });
        const newuser = user;
        newuser.followers.push(currentuser._id);
        setuser(newuser);
      }
    } catch (error) {
      console.log(error );
    }
    setisfollow(!isfollow);
  }

  return (
    <>
      <Topbar />

      {showalert ? <div style={{ 'height': '45px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
        <Alertjs allertmessage={"Plese write something and try again..."} />
      </div> : ""}

      <div className="profilePage">
        {loading ? <Progress /> : <div className="profile">
          <div className="profileSecond">
            <img className="profileUserImg" src={user.profilePic ? user.profilePic : PF + "person/noprofile.png"} />
            <h2>{user.username}</h2>
            <hr />
            <div className="profileBtn">
              <button className='btn' onClick={(e) => { setshowfollowers(!showfollowers); setshowfollowings(false) }}>{"Followers"}{showfollowers ? <ArrowDropDownIcon></ArrowDropDownIcon> : ""}</button>
              <button className='btn' onClick={(e) => { setshowfollowings(!showfollowings); setshowfollowers(false) }}>{"Following"}{showfollowings ? <ArrowDropDownIcon></ArrowDropDownIcon> : ""}</button>
              {(userID !== currentuser._id) && (<button onClick={followfun} className='btn followBtn'>{isfollow ? "Unfollow" : "Follow"}{isfollow ? <PersonRemoveIcon /> : <PersonAddAlt1Icon />}</button>)}
              {(userID === currentuser._id) && (<button onClick={()=>{navigate('/updateprofile')}} className='btn'>Edit Profile</button>)}
            </div>
          </div>

          <div className="middlediv">
            {showfollowers && (<div className="followersDiv">
              <h2 style={{ 'textAlign': 'center', 'marginTop': '8px' }}>Followers</h2>
              {(user.followers.length == 0) && <p style={{ 'marginTop': '5px','marginBottom':'5px', 'textAlign': 'center' }}>User does not have followers!</p>}
              {user.followers.map((it) => (
                <CloseFriend key={it._id} id={it} />
              ))}
            </div>)}
            {showfollowings && (<div className="followersDiv">
              <h2 style={{ 'textAlign': 'center', 'marginTop': '8px' }}>Following</h2>
              {(user.followings.length == 0) && <p style={{ 'marginTop': '5px', 'textAlign': 'center','marginBottom':'5px' }}>User does not follow any users!</p>}
              {user.followings.map((it) => (
                <CloseFriend key={"43434"} id={it} />
              ))}
            </div>)}
            <div className="followingsDiv"></div>
          </div>


          <div className="profilethird">
            {/*<div className="intro">
              <div className="profile-intro">
                <h3 style={{ color: 'black', fontWeight: '700' }}>Intro</h3>
                <ul>
                  <li><img src={PF + "/profile-job.png"} />Director at 99media Ltd</li>
                  <li><img src={PF + "profile-study.png"} /> Studing at IIIT kalyani</li>
                  <li><img src={PF + "profile-study.png"} /> Went to RNP</li>
                  <li><img src={PF + "profile-home.png"} /> Lives in Chapra, Bihar</li>
                  <li><img src={PF + "profile-location.png"} /> Form India</li>
                  <li><img style={{ width: '23px', marginLeft: '3px', marginRight: '15px', opacity: '0.6' }} src={PF + "relation.png"} /> Single</li>
                  {(currentuser._id == user._id) && (<button className='btn' style={{ width: '100%' }}>Edit details</button>)}
                </ul>
              </div>
              </div>*/}
            <div className="profilePageShare">
              {/*<Feed user={user.username} />*/}
              <UserPost user={userID} />
            </div>
          </div>
        </div>}
      </div>
      <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
        <p style={{ 'textAlign': 'center', opacity: '0.6' }}>Copyright ©2022-Alok.info | All rights reserved</p>
      </div>
      <Bottom />
    </>
  );
}

